export const routes = {
  HOME: '/',
  GAME: '/game/:roomUuid',
  ONBOARDING: '/onboarding',
} as const
